import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import emptyTable from '../../assets/images/empty-table.svg';

interface EmptyTableProps {
  text: PlainText | React.ReactNode;
}

let EmptyData = function ({ text }: EmptyTableProps): ReactElement {
  return (
    <EmptyWrapper>
      <Icon src={emptyTable}></Icon>
      <Text>{text}</Text>
    </EmptyWrapper>
  );
};

const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  height: 100%;
`;

const Icon = styled.img``;
const Text = styled.div`
  padding-top: 12px;
  text-align: center;
  white-space: pre-line;
`;

EmptyData = observer(EmptyData);

export { EmptyData };
